import { IBook } from "../book.types";

export const DEFAULT_BOOK_NAME = 'Mishna';
export const DEFAULT_CATEGORY_NAME = 'Pirkei Avot';

export const BOOK_LIST: IBook[] = [
    {
        id: 1,
        name_en: 'Mishna',
        name_he: "משנה סדורה"
    },
    {
        id: 2,
        name_en: 'Siddur_Ashkenaz',
        name_he: "סידור אשכנז"
    },
    {
        id: 3,
        name_en: 'Torah',
        name_he: "תורה"
    },
    {
        id: 4,
        name_en: 'Neviim',
        name_he: "נביאים"
    },
    {
        id: 5,
        name_en: 'Ketuvim',
        name_he: "כתובים"
    },
]

/**
 * Converts Hebrew book label to English book name using BOOK_LIST
 * @param hebrewLabel - Hebrew label of the book
 * @returns English name if found, original input if not found
 */
export const getEnglishBookName = (hebrewLabel: string): string => {
    // Special case: if input is just "משנה", convert to "משנה סדורה"
    let searchLabel = hebrewLabel;
    if (hebrewLabel === "משנה") {
        searchLabel = "משנה סדורה";
    }
    
    // First try to find by Hebrew name
    const bookByHebrew = BOOK_LIST.find(b => b.name_he === searchLabel);
    if (bookByHebrew && bookByHebrew.name_en) {
        return bookByHebrew.name_en;
    }
    
    // If not found by Hebrew name, try to find by English name (case-insensitive)
    const bookByEnglish = BOOK_LIST.find(b => b.name_en && b.name_en.toLowerCase() === hebrewLabel.toLowerCase());
    if (bookByEnglish && bookByEnglish.name_en) {
        return bookByEnglish.name_en;
    }
    
    // Return original if not found
    return hebrewLabel;
};

/**
 * Converts English book name to Hebrew book label using BOOK_LIST
 * @param englishName - English name of the book
 * @returns Hebrew label if found, original input if not found
 */
export const getHebrewBookLabel = (englishName: string): string => {
    const book = BOOK_LIST.find(b => b.name_en === englishName);
    return book && book.name_he ? book.name_he : englishName; // Return original if not found (might already be Hebrew)
};

/**
 * Gets book name (Hebrew or English) by book ID
 * @param bookId - The book ID
 * @param preferHebrew - Whether to prefer Hebrew name (defaults to true)
 * @returns Book name if found, null if not found
 */
export const getBookNameById = (bookId: number, preferHebrew = true): string | null => {
    const book = BOOK_LIST.find(b => b.id === bookId);
    if (!book) return null;
    
    if (preferHebrew) {
        return book.name_he || book.name_en || null;
    } else {
        return book.name_en || book.name_he || null;
    }
};